import { createSelector } from 'reselect';

import type { RootState } from '/business/shared/state/store';
import { getReduceCompletionVersionSelector } from '/business/shared/state/selectors/application/basket_meta/getBasketMetaSelector';
import isReduceCompletedSelectorV1 from './isReduceCompletedSelectorV1';
import isReduceCompletedSelectorV2 from './isReduceCompletedSelectorV2';

export default createSelector(
  [
    getReduceCompletionVersionSelector,

    (state: RootState) => isReduceCompletedSelectorV1(state),
    (state: RootState) => isReduceCompletedSelectorV2(state),
  ],
  (reduceVersion = 2, v1ReduceComplete, v2ReduceComplete) => {
    if (reduceVersion === 2) {
      return v2ReduceComplete;
    }
    return v1ReduceComplete;
  },
);
